module.exports = __webpack_public_path__ + "static/media/open-envelope.486b6f32.png";